export class App {
    public AppId: number;
    public AppName: string;
    public AppUrl: string;
    public AppConfig: string;
}
